import { Injectable } from "@angular/core";
import { RequestListType } from "app/bundles/requests/shared/enums/request-list-type.enum";
import { Feature } from "app/bundles/requests/shared/models/feature";
import { IGeojsonRequest } from "app/bundles/requests/shared/models/geojsonRequest";
import { Properties } from "app/bundles/requests/shared/models/properties";
import { IWorkorderOrServiceRequestSummary } from "app/bundles/requests/shared/models/request";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, Subject } from "rxjs";

export interface FilterListChange {
  filterType: string;
  value: any;
}

@Injectable()
export class CoreService {
  private notify = new Subject<any>();
  notifyObservable = this.notify.asObservable();

  private listType = new Subject<RequestListType>();
  public listType$: Observable<RequestListType>;

  private zoomMarker = new Subject<Properties>();
  public zoomMarker$: Observable<Properties>;

  private requestSelectionFromList =
    new Subject<IWorkorderOrServiceRequestSummary>();
  public requestSelectionFromList$: Observable<IWorkorderOrServiceRequestSummary>;

  private refreshIcons = new Subject<boolean>();
  public refreshIcons$: Observable<boolean>;

  private requestIconClicked = new Subject<Properties>();
  public requestIconClicked$: Observable<Properties>;

  private updateMap = new Subject<IGeojsonRequest>();
  public updateMap$: Observable<IGeojsonRequest>;

  private updateHandleEvent = new Subject<boolean>();
  public updateHandlerEvent$: Observable<boolean>;

  private currentSelectedRequest =
    new Subject<IWorkorderOrServiceRequestSummary>();
  public currentSelectedRequest$: Observable<IWorkorderOrServiceRequestSummary>;

  private updateRequest = new Subject<number[]>();
  public updateRequest$: Observable<number[]>;

  private resetToDefaultZoom = new Subject<boolean>();
  public resetToDefaultZoom$: Observable<boolean>;

  private scrollToRequest = new Subject<Feature>();
  public scrollToRequest$: Observable<Feature>;

  private resetSearchBox = new Subject<boolean>();
  public resetSearchBox$: Observable<boolean>;

  private resetFilter = new Subject<boolean>();
  public resetFilter$: Observable<boolean>;

  private filterListChange = new Subject<FilterListChange>();
  public filterListChange$: Observable<FilterListChange>;

  constructor(private spinnerService: NgxSpinnerService) {
    this.listType$ = this.listType.asObservable();
    this.zoomMarker$ = this.zoomMarker.asObservable();
    this.requestSelectionFromList$ =
      this.requestSelectionFromList.asObservable();
    this.refreshIcons$ = this.refreshIcons.asObservable();
    this.requestIconClicked$ = this.requestIconClicked.asObservable();
    this.updateMap$ = this.updateMap.asObservable();
    this.updateHandlerEvent$ = this.updateHandleEvent.asObservable();
    this.currentSelectedRequest$ = this.currentSelectedRequest.asObservable();
    this.updateRequest$ = this.updateRequest.asObservable();
    this.resetToDefaultZoom$ = this.resetToDefaultZoom.asObservable();
    this.scrollToRequest$ = this.scrollToRequest.asObservable();
    this.resetSearchBox$ = this.resetSearchBox.asObservable();
    this.resetFilter$ = this.resetFilter.asObservable();
    this.filterListChange$ = this.filterListChange.asObservable();
  }

  public notifyListType(listType: RequestListType) {
    this.listType.next(listType);
  }

  public notifyZoomMarker(requestProperties: Properties) {
    this.zoomMarker.next(requestProperties);
  }

  public notifyRequestSelectionFromList(
    request: IWorkorderOrServiceRequestSummary,
  ) {
    this.requestSelectionFromList.next(request);
  }

  public notifyCenterOnMarkers(data: any) {
    this.notify.next(data);
  }

  public notifyRequestUpdate(ids: number[]) {
    this.updateRequest.next(ids);
  }

  public notifyResetZoom() {
    this.resetToDefaultZoom.next(true);
  }

  public notifyMapUpdate(geoJsonRequest: IGeojsonRequest) {
    this.updateMap.next(geoJsonRequest);
  }

  public notifyHandlerEventUpdate() {
    this.updateHandleEvent.next(true);
  }

  public notifyCurrentSelectedRequest(
    request: IWorkorderOrServiceRequestSummary,
  ) {
    this.currentSelectedRequest.next(request);
  }

  public notifyCenterOnMarker(data: any) {
    this.notify.next(data);
  }

  public notifySearchFilterParameter(data: any) {
    this.notify.next(data);
  }

  public notifyRequestIconClicked(requestProperties: Properties) {
    this.requestIconClicked.next(requestProperties);
  }

  public startSpinner() {
    void this.spinnerService.show();
  }

  public stopSpinner() {
    if (environment.userExperience.alwaysShowSpinnerEvenIfFast) {
      setTimeout(() => this.spinnerService.hide(), 50);
    } else {
      setTimeout(() => this.spinnerService.hide(), 0);
    }
  }

  public notifyScrollToRequest(feature: Feature) {
    this.scrollToRequest.next(feature);
  }

  public notifyRefreshIcons() {
    this.refreshIcons.next(true);
  }

  public notifyResetSearchBox() {
    this.resetSearchBox.next(true);
  }

  public notifyResetFilter() {
    this.resetFilter.next(true);
  }

  public notifyFilterListChange(data: any) {
    this.filterListChange.next(data);
  }
}
